<template>
  <div>
    <b-form
      class="position-relative"
    >
      <b-row>
        <b-col md="12">
          <b-card
            border-variant="success"
            bg-variant="transparent"
            class="shadow-none module-card"
          >
            <b-overlay
              :show="busy"
              rounded="lg"
              opacity="0.6"
            >
              <template #overlay>
                <div class="d-flex align-items-center">
                  <b-spinner
                    small
                    type="grow"
                    variant="secondary"
                  />
                  <b-spinner
                    type="grow"
                    variant="dark"
                  />
                  <b-spinner
                    small
                    type="grow"
                    variant="secondary"
                  />

                  <!-- We add an SR only text for screen readers -->
                  <span class="sr-only">{{ $t('DEBTIA_PLEASE_WAIT_MSG') }}</span>
                </div>
              </template>
              <b-form-group
                :label="$t('DEBTIA_RECIPIENT')"
                label-for="receipient"
              >
                <v-select
                  v-model="receipient"
                  :disabled="busy"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="ReceipientOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  input-id="receipient"
                />
              </b-form-group>
              <b-form-group
                label-for="letter_template"
                :aria-hidden="busy ? 'true' : null"
                class="col-6 inline-block"
              >
                <b-form-checkbox
                  v-model="awaitPayment"
                  checked="true"
                  class="custom-control-success"
                  switch
                >
                  {{ $t('DEBTIA_MOVE_ON_TEXT') }}
                </b-form-checkbox>
              </b-form-group>
              <b-form-group
                label-for="letter_template"
                :aria-hidden="busy ? 'true' : null"
                class="col-6 inline-block"
              >
                <b-form-input
                  v-model="days"
                  placeholder="Days"
                  :disabled="!awaitPayment"
                />
              </b-form-group>
              <b-form-group>
                <b-form-textarea
                  id="textarea-default"
                  v-model="description"
                  placeholder="Description"
                  rows="3"
                />
              </b-form-group>
              <hr>
              <b-form-group
                v-if="receipient === 'client'"
                :label="$t('DEBTIA_EMAIL_TEMPLATE_TEXT')"
                label-for="email_template"
                :aria-hidden="busy ? 'true' : null"
              >
                <v-select
                  v-model="emailTemplate"
                  :disabled="busy"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="emailTemplateOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  :input-id="'email-template'"
                  @input="changeTemplate()"
                />
              </b-form-group>
              <div
                v-if="receipient === 'client'"
              >
                <b-form-group
                  v-for="(data,index) in templateVariables"
                  :key="index"
                  :label="data"
                  label-for="email_template"
                  :aria-hidden="busy ? 'true' : null"
                >
                  <div :id="'div-wrapper-'+data">
                    <v-select
                      :disabled="busy"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="templateVariableOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      :input-id="'email-template-'+data"
                      :class="'email-template-'+data"
                      @input="changeVariable($event, data)"
                    >
                      <template
                        slot="option"
                        slot-scope="option"
                      >
                        <div :class="assignClass(option.value) ? 'autofik' : ''">
                          {{ option.label }}
                        </div>
                      </template>
                    </v-select>
                    <b-row
                      :id="'date-'+data"
                      class="showdates"
                    >
                      <b-col md="12">
                        <b-form-group
                          :label="$t('DEBTIA_SELECT_DAYS_MSG')"
                          label-for="email_template"
                        >
                          <b-form-input
                            :id="'noOfDays-'+data"
                            type="number"
                            @change="noOfDaysChange($event, data)"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                </b-form-group>
              </div>
              <hr>
              <b-form-group>
                <p>{{ $t('DEBTIA_BUTTON_OPTIONS') }}</p>
              </b-form-group>
              <b-row>
                <b-form-group
                  label-for="letter_template"
                  :aria-hidden="busy ? 'true' : null"
                  class="col-5 inline-block"
                >
                  <b-form-input
                    v-model="btnText1"
                    placeholder="Button Text"
                  />
                </b-form-group>

                <b-form-group
                  label-for="letter_template"
                  :aria-hidden="busy ? 'true' : null"
                  class="col-5 inline-block"
                >
                  <v-select
                    v-model="selectedColor1"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="colorOptions"
                    :clearable="false"
                    input-id="selectedColor1"
                    class="colorinput"
                  >
                    <template
                      slot="option"
                      slot-scope="option"
                    >
                      <div
                        class="smallcolors option-display"
                        :style="'background-color:'+option.colorcode+'; border: 1px solid '+option.bordercolorcode+';'"
                      /> <div class="option-display ">
                        {{ option.text }}</div>
                    </template>
                  </v-select>
                </b-form-group>
                <b-form-checkbox
                  v-model="require_reason_description1"
                  class="custom-control-primary col-2"
                  @change="reasonDescriptionChange(0, 1)"
                />
              </b-row>
              <b-row
                v-if="require_reason_description1"
                class="margin-btm-15"
              >
                <b-form-textarea
                  id="textarea-rows"
                  v-model="reason_description1"
                  class="col-12"
                  :placeholder="$t('DEBTIA_REASON_DESCRIPTION')"
                  rows="2"
                />
              </b-row>
              <b-row>
                <b-form-group
                  label-for="letter_template"
                  :aria-hidden="busy ? 'true' : null"
                  class="col-5 inline-block"
                >
                  <b-form-input
                    v-model="btnText2"
                    placeholder="Button Text"
                  />
                </b-form-group>
                <b-form-group
                  label-for="letter_template"
                  :aria-hidden="busy ? 'true' : null"
                  class="col-5 inline-block"
                >
                  <v-select
                    v-model="selectedColor2"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="colorOptions"
                    :clearable="false"
                    input-id="selectedColor2"
                    class="colorinput"
                  >
                    <template
                      slot="option"
                      slot-scope="option"
                    >
                      <div
                        class="smallcolors option-display"
                        :style="'background-color:'+option.colorcode+'; border: 1px solid '+option.bordercolorcode+';'"
                      /> <div class="option-display ">
                        {{ option.text }}</div>
                    </template>
                  </v-select>
                </b-form-group>
                <b-form-checkbox
                  v-model="require_reason_description2"
                  class="custom-control-primary col-2"
                  @change="reasonDescriptionChange(0, 2)"
                />
              </b-row>
              <b-row
                v-if="require_reason_description2"
                class="margin-btm-15"
              >
                <b-form-textarea
                  id="textarea-rows"
                  v-model="reason_description2"
                  class="col-12"
                  :placeholder="$t('DEBTIA_REASON_DESCRIPTION')"
                  rows="2"
                />
              </b-row>
              <b-row
                v-for="(data,index) in items"
                :key="index"
              >
                <b-form-group
                  label-for="letter_template"
                  :aria-hidden="busy ? 'true' : null"
                  class="col-1 inline-block"
                >
                  <b-button
                    variant="gradient-danger"
                    class="btn-icon rounded-circle"
                    size="sm"
                    @click="removeButton(index)"
                  >
                    <feather-icon icon="Trash2Icon" />
                  </b-button>
                </b-form-group>
                <b-form-group
                  label-for="letter_template"
                  :aria-hidden="busy ? 'true' : null"
                  class="col-4 inline-block"
                >
                  <b-form-input
                    v-model="data.button_title"
                    placeholder="Button Text"
                  />
                </b-form-group>

                <b-form-group
                  label-for="letter_template"
                  :aria-hidden="busy ? 'true' : null"
                  class="col-5 inline-block"
                >
                  <v-select
                    v-model="data.button_color"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="colorOptions"
                    :clearable="false"
                    :input-id="'btncolor-'+data.btn_id"
                    class="colorinput"
                  >
                    <template
                      slot="option"
                      slot-scope="option"
                    >
                      <div
                        class="smallcolors option-display"
                        :style="'background-color:'+option.colorcode+'; border: 1px solid '+option.bordercolorcode+';'"
                      /> <div class="option-display ">
                        {{ option.text }}</div>
                    </template>
                  </v-select>
                </b-form-group>
                <b-form-checkbox
                  v-model="data.require_reason_description"
                  class="custom-control-primary col-1"
                  @change="reasonDescriptionChange(1, index)"
                />
                <b-col
                  v-if="data.require_reason_description"
                  class="col-12 margin-btm-15"
                >
                  <b-form-textarea
                    id="textarea-rows"
                    v-model="data.reason_description"
                    :placeholder="$t('DEBTIA_REASON_DESCRIPTION')"
                    rows="2"
                  />
                </b-col>
              </b-row>
              <b-form-group
                class="text-center"
              >
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="btn-icon rounded-circle"
                  @click="addButtonRow"
                >
                  <feather-icon
                    icon="PlusIcon"
                  />
                </b-button>
              </b-form-group>
              <hr>
            </b-overlay>

            <b-button
              class="emailSubmitBtn"
              variant="primary"
              type="submit"
              @click.prevent="fieldsfilled"
            >
              <b-spinner
                v-if="spinnerOn"
                small
                class="mr-1"
                label="Small Spinner"
              />
              <span v-else>{{ $t('DEBTIA_SUBMIT') }}</span>
            </b-button>
            <span
              v-if="errorMsg && receipient === 'client'"
              id="fieldserror"
            >{{ $t('DEBTIA_TEMPLATE_FIELDS_REQUIRED') }}</span>
          </b-card>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>

import vSelect from 'vue-select'
import {
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BOverlay,
  BCard,
  BSpinner,
  BFormInput,
  BFormCheckbox,
  BFormTextarea,
} from 'bootstrap-vue'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import i18n from '@/libs/i18n'
import axiosemailv1 from '../../../libs/axiosemailv1'
import axiosemail from '../../../libs/axiosemail'
// import axios from '@axios'
import 'animate.css'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BForm,
    BRow,
    BCol,
    BFormGroup,
    vSelect,
    BOverlay,
    BSpinner,
    BCard,
    BButton,
    BFormInput,
    BFormCheckbox,
    BFormTextarea,
  },
  directives: {
    Ripple,
  },
  props: {
    conditionObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      emailvariables: {
        debtiaReceipientsClient: 'debtia.userActionClient',
      },
      templateVariables: [],
      emailTemplate: '',
      emailTemplateOptions: [],
      busy: false,
      errorMsg: false,
      spinnerOn: false,
      ReceipientOptions: [
        { label: 'Creditor', value: 'client' },
        { label: 'Partner', value: 'partner' },
        { label: 'Employee', value: 'employee' },
      ],
      receipient: 'client',
      productsObj: null,
      fields: [
        { key: 'name', label: 'Product' },
        { key: 'quantity', label: 'Quantity' },
        { key: 'price', label: 'Price' },
      ],
      items: [],
      subTotal: 0.00,
      vat: 0,
      total: 0.00,
      awaitPayment: true,
      colorOptions: [
        {
          label: 'Primary',
          value: 'primary',
          text: 'Primary',
          colorcode: '#219289',
          bordercolorcode: '#04665f',
        },
        {
          value: 'secondary',
          text: 'Secondary',
          colorcode: '#82868b',
          bordercolorcode: '#6b6d70',
        },
        {
          value: 'success',
          text: 'Success',
          colorcode: '#28c76f',
          bordercolorcode: '#12994e',
        },
        {
          value: 'info',
          text: 'Info',
          colorcode: '#00cfe8',
          bordercolorcode: '#069daf',
        },
        {
          value: 'warning',
          text: 'Warning',
          colorcode: '#ff9f43',
          bordercolorcode: '#e78628',
        },
        {
          value: 'danger',
          text: 'Danger',
          colorcode: '#ea5455',
          bordercolorcode: '#cb1415',
        },
        {
          value: 'dark',
          text: 'Dark',
          colorcode: '#4b4b4b',
          bordercolorcode: '#262525',
        },
      ],
      selectedColor1: null,
      selectedColor2: null,
      btnText1: '',
      btnText2: '',
      require_reason_description1: false,
      require_reason_description2: false,
      reason_description1: '',
      reason_description2: '',
      days: '',
      description: '',
      btn: 0,
      specialOptions: [
        { name: 'dato_felt', label: 'Select number of days after letter generation' },
        { name: 'auto_fik', label: '' },
        { name: 'debtia.recepient_name', label: 'Enter recepient name.' },
        { name: 'debtia.recepient_contact_person', label: 'Enter recepient contact person' },
        { name: 'debtia.recepient_road_name', label: 'Enter recepient address road name' },
        { name: 'debtia.recepient_house_number', label: 'Enter recepient house number' },
        { name: 'debtia.recepient_zipcode', label: 'Enter recepient zipcode' },
        { name: 'debtia.recepient_city', label: 'Enter recepient city' },
        { name: 'debtia.recepient_country', label: 'Enter recepient country' },
        { name: 'debtia.recepient_place', label: 'Enter recepient place' },
      ],
      communication_client_id: '',
      communication_secret: '',
    }
  },
  created() {
    this.getApiSettings()
  },
  methods: {
    reasonDescriptionChange(type, index) {
      if (type === 0) {
        if (index === 1) {
          if (!this.require_reason_description1) this.reason_description1 = ''
        }
        if (index === 2) {
          if (!this.require_reason_description2) this.reason_description2 = ''
        }
      }
      if (type === 1) {
        if (!this.items[index].require_reason_description) this.items[index].reason_description = ''
      }
    },
    async getApiSettings() {
      await axios.get('/api-token/default?module=communication').then(settings => {
        if (settings.status) {
          this.communication_client_id = settings.data.data.client_id
          this.communication_secret = settings.data.data.secret
          this.getEmailTemplates()
        }
      })
    },
    assignClass(field) {
      let exists = false
      const entry = this.specialOptions.filter(e => e.name === field)
      // console.log('exists ', entry.length)
      if (entry.length > 0) {
        exists = true
      }
      return exists
    },
    changeVariable(event, variable) {
      this.$el.querySelector(`.email-template-${variable}`).classList.remove('inputErrorClass')
      if (event === 'dato_felt') {
        document.getElementById(`div-wrapper-${variable}`).classList.add('div-wrapper')
        document.getElementById(`date-${variable}`).style.display = 'block'
        this.emailvariables[variable] = {
          variable: event,
          functional_value: 0,
        }
      } else {
        this.emailvariables[variable] = event
        document.getElementById(`div-wrapper-${variable}`).classList.remove('div-wrapper')
        document.getElementById(`date-${variable}`).style.display = 'none'
      }
      const emptyValues = this.templateVariables.filter(element => !this.emailvariables[element])
      if (emptyValues.length === 0) {
        this.errorMsg = false
      }
    },
    changeTemplate() {
      this.busy = true
      this.templateVariables = []
      this.templateVariableOptions = []
      const url = `/template/get-template-vars-api/${this.emailTemplate}`
      const headers = {
        clientId: this.communication_client_id,
        secret: this.communication_secret,
      }
      axiosemail.get(url, {
        headers,
      }).then(response => {
        if (response.status === 200) {
          // console.log()
          setTimeout(() => {
            this.busy = false
            const object = response.data.data.template_custom_fields
            this.emailTemplateTitle = response.data.data.template.name
            // response.data.data.data.name
            object.forEach(element => {
              this.templateVariables.push(element.custom_field)
            })
            this.attachVariables()
          }, 2000)
        }
      })
    },
    attachVariables() {
      this.templateVariableOptions = [
        { label: 'clients.name', value: 'clients.name' },
        { label: 'debtors.name', value: 'debtors.name' },
        { label: 'debtors.phone', value: 'debtors.phone' },
        { label: 'debtors.contact_person', value: 'debtors.contact_person' },
        { label: 'debtor_addresses.road_name', value: 'debtor_addresses.road_name' },
        { label: 'debtor_addresses.house_no', value: 'debtor_addresses.house_no' },
        { label: 'debtor_addresses.zip_code', value: 'debtor_addresses.zip_code' },
        { label: 'debtor_addresses.city', value: 'debtor_addresses.city' },
        { label: 'debt_case_info.payment_amount', value: 'debt_case_info.payment_amount' },
        { label: 'debt_case_info.interest_rate_percentage', value: 'debt_case_info.interest_rate_percentage' },
        { label: 'debt_case_info.reminder_fee', value: 'debt_case_info.reminder_fee' },
        { label: 'debt_case_info.paid_amount', value: 'debt_case_info.paid_amount' },
        { label: 'debt_case_info.credit_note_amount', value: 'debt_case_info.credit_note_amount' },
        { label: 'debt_case_info.total_amount', value: 'debt_case_info.total_amount' },
        { label: 'debt_cases.id', value: 'debt_cases.id' },
        { label: 'debtor.co', value: 'debtor.co' },
        { label: 'debtor.addresses.place', value: 'debtor.addresses.place' },
        { label: 'debt_case_info.principal', value: 'debt_case_info.principal' },
        { label: 'Await Days', value: 'await.days' },
        { label: 'Link', value: 'debtia.link' },
        { label: 'debt_case_info.total_rest', value: 'debt_case_info.total_rest' },
        { label: 'dato felt', value: 'dato_felt' },
        { label: 'Auto FIK', value: 'auto_fik' },
        { label: 'Recepient Name', value: 'debtia.recepient_name' },
        { label: 'Recepient Contact Person', value: 'debtia.recepient_contact_person' },
        { label: 'Recepient Address Road Name', value: 'debtia.recepient_road_name' },
        { label: 'Recepient Address House Number', value: 'debtia.recepient_house_number' },
        { label: 'Recepient Address Zipcode', value: 'debtia.recepient_zipcode' },
        { label: 'Recepient Address City', value: 'debtia.recepient_city' },
        { label: 'Recepient Address Country', value: 'debtia.recepient_country' },
        { label: 'Recepient Address Place', value: 'debtia.recepient_place' },
      ]
    },
    getEmailTemplates() {
      this.busy = true
      const url = '/email/get-templates'
      const headers = {
        clientId: this.communication_client_id,
        secret: this.communication_secret,
      }
      axiosemailv1.get(url, {
        headers,
      }).then(response => {
        if (response.status === 200) {
          const records = response.data.data
          records.forEach(element => {
            const elementObj = { label: element.name, value: element.id }
            this.emailTemplateOptions.push(elementObj)
          })
          setTimeout(() => {
            this.busy = false
          }, 2000)
        }
      })
    },
    fieldsfilled() {
      const emptyValues = this.templateVariables.filter(element => (!this.emailvariables[element] || (this.emailvariables[element] && this.emailvariables[element].functional_value === 0)))
      if (emptyValues.length > 0 && this.receipient === 'client') {
        emptyValues.forEach(element => {
          let selector = ''
          let classToPut = ''
          if (this.emailvariables[element] && this.emailvariables[element].functional_value === 0) {
            selector = `#noOfDays-${element}`
            classToPut = 'inputErrorClassField'
          } else {
            selector = `.email-template-${element}`
            classToPut = 'inputErrorClass'
          }
          this.$el.querySelector(selector).classList.add(classToPut)
        })
        this.errorMsg = true
      } else {
        // eslint-disable-next-line no-lonely-if
        if (
          (this.awaitPayment && !this.days)
          || !this.description
          || !this.btnText1
          || !this.selectedColor1
          || !this.btnText2
          || !this.selectedColor2
          || (this.receipient === 'client' && !this.emailTemplate)
        ) {
          this.bounceInError()
        } else {
          this.checkAdditionalButtons()
        }
      }
    },
    checkAdditionalButtons() {
      if (this.items.length > 0) {
        const arr = this.items.filter(element => !element.button_color || !element.button_title)
        if (arr.length > 0) {
          this.emptyButtonsConfirmText()
        } else {
          this.submit()
        }
      } else {
        this.submit()
      }
    },
    async submit() {
      const btn1 = {
        button_color: this.selectedColor1.value,
        button_title: this.btnText1,
        require_reason_description: this.require_reason_description1,
        reason_description: this.reason_description1,
      }
      const btn2 = {
        button_color: this.selectedColor2.value,
        button_title: this.btnText2,
        require_reason_description: this.require_reason_description2,
        reason_description: this.reason_description2,
      }
      this.items.forEach((element, index) => {
        if (typeof element.button_color === 'object') {
          this.items[index].button_color = element.button_color.text
        }
      })
      const buttons = [btn1, btn2, ...this.items]
      const processID = this.$route.params.id
      const emailTemplate = this.receipient === 'client' ? this.emailTemplate : 0
      const emailTemplateVars = this.receipient === 'client' ? this.emailvariables : {}
      const dataObj = {
        process_id: Number(processID),
        module_id: 9,
        module_order: 1,
        recipient: this.receipient,
        description: this.description,
        await: this.awaitPayment,
        await_days: Number(this.days),
        buttons,
        email_template_id: emailTemplate,
        custom_variables: emailTemplateVars,
      }
      if (this.conditionObject.moduleID > 0) {
        dataObj.depends_on = this.conditionObject.moduleID
        dataObj.condition = this.conditionObject.type
      }
      const url = '/process/module/add'
      axios.post(url, dataObj).then(response => {
        if (response.status === 200) {
          this.awaitType = 0
          this.days = ''
          const returnObj = {
            parentID: this.conditionObject.parentID,
            depend: dataObj.depends_on,
          }
          returnObj.type = this.conditionObject.type ? this.conditionObject.type : 0
          this.$emit('closeUserActionModal', returnObj)
        }
      })
    },
    bounceInError() {
      this.$swal({
        title: 'Error',
        text: i18n.t('DEBTIA_INSERT_DATA_TEXT'),
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    emptyButtonsConfirmText() {
      this.$swal({
        text: i18n.t('DEBTIA_CONTINUE_TEXT'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          const arr = this.items.filter(element => element.button_color.value && element.button_title)
          this.items = arr
          this.submit()
        }
      })
    },
    addButtonRow() {
      this.btn += 1
      const products = {
        btn_id: this.btn,
        button_color: '',
        button_title: '',
        require_reason_description: false,
        reason_description: '',
      }
      this.items.push(products)
    },
    removeButton(i) {
      this.items.splice(i, 1)
    },
    noOfDaysChange(data, event) {
      this.emailvariables[event].functional_value = Number(data)
      this.$el.querySelector(`#noOfDays-${event}`).classList.remove('inputErrorClassField')
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .emailSubmitBtn {
    width: 100%;
  }

  .inputErrorClass .vs__dropdown-toggle{
    border-color: red !important;
  }

  .inputErrorClassField{
    border-color: red !important;
  }

  #fieldserror {
    color: red;
  }

  .showdates {
    display: none;
    margin-top: 10px;
  }

  .autofik {
    margin-left: -10px;
    width: 106%;
    border-radius: 4px;
    padding: 10px;
    color: white;
    background-color: #5fb3ac !important;
    box-shadow: 1px 1px 2px #d3e8e6, 0 0 15px #d3e8e6, 0 0 2px #d3e8e6;
  }

  div.div-wrapper {
    border: 1px solid #d8d6de;
    border-radius: 5px;
    padding: 10px 10px 0px 10px;
  }

  .left{
    float: left;
  }
  .right{
    float: right;
  }

  .table-style {
    max-height: 300px;
  }
  .inline-block{
    display: inline-block;
  }

  .middle-input-style {
    margin-left: 5px;
    padding-right: 0px;
    width: 40%;
  }

  .smallcolors {
    height: 15px;
    width: 15px;
    border-radius: 3px;
  }

  .option-display {
    display: inline-block;
    margin-left: 5px;
  }

  .wronginput {
    border-color: red;
  }

  .autofik {
    margin-left: -10px;
    width: 106%;
    border-radius: 4px;
    padding: 10px;
    color: white;
    background-color: #5fb3ac !important;
    box-shadow: 1px 1px 2px #d3e8e6, 0 0 15px #d3e8e6, 0 0 2px #d3e8e6;
  }
  #fieldserror {
    color: red;
  }

  .inputErrorClassField{
    border-color: red !important;
  }

  .margin-btm-15 {
    margin: 0px 0px 15px 0px;
  }
</style>
